define(["marionette", "underscore", "messaging/messenger", "./generalConfigView"], function (
  Marionette,
  _,
  Messenger,
  GeneralConfigView,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userAdminGeneralConfig";
      this.region = options.region;
      this.user = options.user;
    },
    show: function () {
      const kbs = Messenger.reqres.request("kb:list");
      this.user.kbs = kbs;

      this.view = new GeneralConfigView.view({
        model: this.user,
      });

      this.view.on("change:default:kb", (kbId) => {
        this.user.get("tenantDefaults").defaultKbId = +kbId;
        this.user.trigger("change");
      });
      this.view.on("change:interface:dateFormat", (dateFormat) => {
        this.user.get("tenantDefaults").dateFormat = dateFormat;
        this.user.trigger("change");
      });
      this.view.on("change:interface:language", (languageId) => {
        this.user.get("tenantDefaults").interfaceLanguageId = +languageId;
        this.user.trigger("change");
      });
      this.view.on("change:showArchivedTopics", (showArchivedTopics) => {
        this.user.get("tenantDefaults").showArchivedTopics = showArchivedTopics;
        this.user.trigger("change");
      });

      // NOTE: This collection do not seem to work quite right with the existing logic to show a loading view,
      // so they have to be handled using onSynced() instead.
      kbs.onSynced(() => {
        this.showRegion(this.view);
      });
    },
  });
});
